import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { deleteToken, getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyDu2OWBbu7hAh64GM9j6Ftd1D7hKBnuM5k",
  authDomain: "recess-68407.firebaseapp.com",
  projectId: "recess-68407",
  storageBucket: "recess-68407.firebasestorage.app",
  messagingSenderId: "514128207933",
  appId: "1:514128207933:web:1eb676e57785257a6dca54",
  measurementId: "G-T2QH949G02"
  };

  const app = initializeApp(firebaseConfig);
  const messaging = getMessaging(app);
  const auth = getAuth(app);
  const googleProvider = new GoogleAuthProvider();

  export const getFirebaseToken = async (setTokenFound) => {
    // Check if token already exists
    const existingToken = sessionStorage.getItem("firebaseToken");
    if (existingToken) {
      console.log("Using existing token:", existingToken);
      setTokenFound?.(existingToken);
      return;
    }
  
    if ('serviceWorker' in navigator) {
      try {
        // Register service worker
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
        console.log('Service Worker registered with scope:', registration.scope);
  
        // Request notification permission
        const permission = await Notification.requestPermission();
  
        if (permission === 'granted') {
          // Get FCM token
          const currentToken = await getToken(messaging, {
            vapidKey: "BM4uML5txBLAVLOq6Fai3oGBQYVxsJQ9kOvOkqBqiELAo6IYJgxUsjkQJ3AEVY4JErThQ_PSREWbBZUeg8aFbX8",
            serviceWorkerRegistration: registration,
          });
  
          if (currentToken) {
            console.log('Current Token:', currentToken);
            sessionStorage.setItem("firebaseToken", currentToken);
            setTokenFound?.(currentToken);
          } else {
            console.log('No registration token available.');
            setTokenFound?.(false);
          }
        } else {
          console.log('Permission denied for notifications.');
          setTokenFound?.(false);
        }
      } catch (error) {
        console.error('An error occurred while retrieving token.', error);
        setTokenFound?.(false);
      }
    } else {
      console.error('Service workers are not supported in this browser.');
      setTokenFound?.(false);
    }
  };
  


  export const deleteFirebaseToken = async (setTokenFound) => {
    try {
      const tokenDeleted = await deleteToken(messaging);
      if (tokenDeleted) {
        console.log("FCM token deleted successfully.");
        setTokenFound(false);
      } else {
        console.log("FCM token deletion unsuccessful.");
      }
    } catch (error) {
      console.error("Error deleting FCM token:", error);
      setTokenFound(false);
    }
  };


  export const onMessageListener = () =>
    new Promise((resolve) => {
      onMessage(messaging, (payload) => {
        resolve(payload);
      });
    });

    export { auth, googleProvider };
